import { useState } from "react";
import { Button } from "@/components/Button";
import { supabase } from "./supabase";
import styles from "./SignIn.module.css";

// Google is the only provider: it is the one all three editors already have,
// and it needs no mail server. Membership is decided elsewhere -- the
// before-user-created hook refuses any account without a staff_user row -- so
// this screen makes no claim about who is allowed in.
export const SignIn = () => {
  const [error, setError] = useState<string | null>(null);
  const [isPending, setIsPending] = useState(false);

  const signIn = async () => {
    setIsPending(true);
    setError(null);

    const { error: failure } = await supabase.auth.signInWithOAuth({
      provider: "google",
      options: { redirectTo: window.location.origin },
    });

    if (failure) {
      setError(failure.message);
      setIsPending(false);
    }
  };

  return (
    <div className={styles.screen}>
      <div className={styles.panel}>
        <h1 className={styles.title}>Quest Editor</h1>
        <p className={styles.blurb}>
          Sign in with the Google account your editor record is under.
        </p>
        <Button variant="primary" onClick={signIn} disabled={isPending}>
          {isPending ? "Redirecting..." : "Sign in with Google"}
        </Button>
        {error ? <p className={styles.error}>{error}</p> : null}
      </div>
    </div>
  );
};
